<script setup>
import { ref } from 'vue'

defineProps({
    padded: {
        type: Boolean,
        default: true,
    },
})

const emit = defineEmits(['is-panel-active'])

const isActive = ref(false)
const offset = ref(0)
const dropdownItem = ref(null)

function emitActivity() {
    emit('is-panel-active', isActive.value)
}

function correctOffset() {
    const elementRect = dropdownItem.value.getBoundingClientRect()
    const windowWidth = window.innerWidth
    if (elementRect.right > windowWidth) {
        offset.value = elementRect.right - windowWidth + 20
    }
}

function toggle() {
    isActive.value = !isActive.value
    emitActivity()
    if (isActive.value) {
        setTimeout(() => {
            correctOffset()
        }, 0)
    }
}

function hide() {
    isActive.value = false
    emitActivity()
}
</script>

<template>
    <div :class="['base-dropdown', isActive && 'active']">
        <div
            class="dropdown-container"
            :style="`transform: translateX(-${offset}px)`"
        >
            <div
                ref="dropdownItem"
                :class="['dropdown', padded && 'padded']"
            >
                <slot name="dropdown" />
            </div>
        </div>
        <div
            v-click-outside="hide"
            class="trigger"
            @click="toggle"
        >
            <slot name="trigger" />
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@design';

.trigger {
    position: relative;
    cursor: pointer;
}

.dropdown {
    @extend %contentSubtitleS;

    position: absolute;
    top: $s-m;
    left: 0;
    z-index: $layer-message-z-index;
    display: none;
    min-width: 240px;
    overflow: hidden;
    text-transform: none;
    border-radius: $radius-5;

    @include elevationOverlay;

    &.padded {
        padding: $s-s $s-m;
    }
}

.dropdown-container {
    position: relative;
    top: $s-m;
    left: 0;
    z-index: $layer-message-z-index;
}

.base-dropdown {
    position: relative;
    &.active .dropdown {
        display: block;
    }
}
</style>
